import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPlayersReport from 'views/reports/playersReport/filterPlayersReport'; // Importing filter component for players report
import TablePlayersReport from 'views/reports/playersReport/tablePlayersReport'; // Importing table component for players report
import DetailsPlayersReport from 'views/reports/playersReport/detailsPlayersReport'; // Importing details component for players report
import RecordPlayersReport from 'views/reports/playersReport/recordPlayersReport'; // Importing record component for players report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PlayersReportView class extends JetView to create a report view for players.
 */
export default class PlayersReportView extends JetView {
    /**
     * Configures the layout of the PlayersReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                DetailsPlayersReport, // Details report component
                RecordPlayersReport, // Record report component
            ],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Page size options
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
            ],
        };
        const left = {
            // Left section configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply theme CSS
                    elements: [
                        { view: 'label', label: _('Reporte de Jugadores') }, // Label for the report title
                    ],
                },
                FilterPlayersReport, // Filter component
                TablePlayersReport, // Table component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            // Advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }], // Header and body for the accordion
        };
        const avancResp = {
            // Responsive advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl', // Unique identifier for the accordion
                    header: _('Detalles Avanzados'), // Header for the accordion
                    body: right, // Body content
                    minWidth: 200,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height; // Variable to store height
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height
                                if (!$$('dColl').config.collapsed) {
                                    // Check if accordion is expanded
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Apply transform for scrolling effect
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Recalculate height
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Apply transform for scrolling effect
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling', // CSS class for styling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer component
                        document.body.offsetWidth < 500 ? avancResp : avanc, // Conditional rendering based on screen width
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the PlayersReportView.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('res').hide(); // Hide resizer if screen is narrow
            }
        });
    }
}

// FILE DOCUMENTED
